import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';

/**
 * Formly field type for radio button group
 *
 * Props:
 * - label: string - Field label
 * - description: string - Helper text
 * - required: boolean - Whether selection is required
 * - options: Array<{value: any, label: string, description?: string, isDefault?: boolean}> - Radio options
 */
@Component({
  selector: 'app-radio-field',
  imports: [ReactiveFormsModule, FormlyModule, TranslatePipe],
  templateUrl: './radio-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './radio-field.component.css',
})
export class RadioFieldComponent extends FieldType<FieldTypeConfig> implements OnInit {
  ngOnInit(): void {
    // Apply default when the control has no value yet (new form interaction)
    if (this.formControl.value === null || this.formControl.value === undefined) {
      const defaultOpt = this.radioOptions.find((o) => o.isDefault);
      if (defaultOpt) {
        this.formControl.setValue(defaultOpt.value);
      }
    }
  }
  /**
   * Get options from props
   */
  get radioOptions(): { value: any; label: string; description?: string; isDefault?: boolean }[] {
    const opts = this.props['options'] as any;
    if (Array.isArray(opts)) {
      return opts;
    }
    return [];
  }
}
